import api from './api';

// Personal access tokens for the Customer.io localization endpoint.
//
// A workspace's configuration is exported, templated and read by more people than any credential
// should answer to, so it cannot hold a shared secret. Each CRM user mints a token here, where
// they are already logged in, and pastes it into the workspace. The plaintext comes back exactly
// once — from then on the server holds only a salted hash.
export const crmTokenAPI = {
  list: () => api.get('/api/crm-tokens'),
  create: (body) => api.post('/api/crm-tokens', body),
  revoke: (id) => api.delete(`/api/crm-tokens/${id}`),
};

export default crmTokenAPI;
